import React from 'react'
import logo_img from '../Images/Logo SVG/logo.svg';
// import logo_img from '../Images/Logo SVG/Sumizan Logo SVG.svg';
import '../CSS/Header.css';

const Logo = () => {
  return (
    <div className="logo_wrapper">
        <img src={logo_img} alt="Logo" className="logo" />
        <span className='logo_text'>NExGEN<span className='red logo_text'>TECH</span></span>
    </div>
  )
}

export default Logo